import { apiFetch } from './client';

export const listAppVersions = (token) => apiFetch(token, '/app-versions');

export const createAppVersion = (token, formData) =>
  apiFetch(token, '/app-versions', { method: 'POST', body: formData });
